import React, { useState } from "react";
import s from "./UploadModal.module.css";

import { useTranslation } from "react-i18next";
import exportService from "../../../../../api/delivery/exportService";

import { Grid, Modal, Button, Snackbar, Alert } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import RaffleModal from "./RaffleModal";
import useTranslationException from "../../../../../helpers/exceptions";

const UploadModal = ({ open, setOpen }) => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const [openRaffle, setOpenRaffle] = useState(false);
  const [noSelect, setNoSelect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [raffleSelected, setRaffleSelected] = useState({});

  const handleGetFile = () => {
    if (!raffleSelected.id) {
      setNoSelect(true);
      console.log("entra2");
    } else {
      exportService
        .getSalesReports(raffleSelected.id, raffleSelected.number)
        .then((res) => {
          console.log(res);
        })
        .catch((e) => {
          console.log("entrsssa");
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
        });
    }
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={11} className={s.exit}>
              <div className={s.titleModal}>
                <p>{t("telekinoSales")}</p>
                <span>{t("downloadFile")}</span>
              </div>
              <CloseIcon
                onClick={() => {
                  setRaffleSelected({});
                  setOpen(false);
                }}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>

            <Grid container item xs={12} className={s.drawNumber}>
              <Grid item xs={12} className={s.drawSelected}>
                {raffleSelected.id ? (
                  <Grid item xs={12} className={s.draw}>
                    <p>{`${t("drawNumber")}: ${raffleSelected.number}`}</p>
                    <p>{`${t("drawDate")}: ${raffleSelected.raffleDate?.split("T")[0].split("-").reverse().join("-")}`}</p>
                  </Grid>
                ) : (
                  t("drawNotSelected")
                )}
              </Grid>
              <Button variant="contained" onClick={() => setOpenRaffle(true)}>
                {raffleSelected.id ? t("change") : t("select")}
              </Button>
            </Grid>

            <Grid container item xs={12} className={s.filters}>
              <label
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Grid
                  container
                  onClick={handleGetFile}
                  item
                  xs={10}
                  className={s.uploadContainer}
                  sx={{
                    "&:hover": {
                      backgroundColor: "secondary.light",
                      cursor: "pointer",
                    },
                  }}
                >
                  <DownloadIcon
                    sx={{ fontSize: "4.5rem", color: "primary.dark" }}
                    className={s.uploadIcon}
                  />
                  <p className={s.textUpload}>{t("downloadFile")}</p>
                </Grid>
              </label>
            </Grid>
          </Grid>
        </Grid>
        {openRaffle ? (
          <RaffleModal
            open={openRaffle}
            setOpen={setOpenRaffle}
            selectRaffle={setRaffleSelected}
          />
        ) : null}
        <Snackbar
          open={noSelect}
          autoHideDuration={6000}
          onClose={() => setNoSelect(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Alert
            variant="filled"
            onClose={() => setNoSelect(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {`${t("select")} ${t("raffle")}`}
          </Alert>
        </Snackbar>
      </Grid>
    </Modal>
  );
};

export default UploadModal;
